import React, { Component } from "react";

type Props = {
  onInputSuccess: (value: string) => void;
  disabled?: boolean;
};

export default class ActionConfirm extends Component<Props> {
  componentDidMount() {
    // HACK: set action value automatically
    this.props.onInputSuccess("ok");
  }

  render() {
    //Nothing to show (yet)
    return null;
  }
}
